module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper container-licencas",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "column all-centered container-validacao box-body"
  }, [_c('validacaoLicencas', {
    attrs: {
      "idProposta": null,
      "nomeProjeto": null,
      "numeroProjeto": null,
      "todasLicencas": true
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b706ab0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/licenciamentoAmbiental/listaValidacaoLicencas.vue
// module id = 1914
// module chunks = 1